import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import bgTranslations from './translations/bg.json';
import enTranslations from './translations/en.json';

const translations = {
  bg: bgTranslations,
  en: enTranslations
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Default language: English. Save selection in localStorage.
  const [language, setLanguage] = useState(() => {
    try {
      const savedLanguage = localStorage.getItem('fireguard_language');
      return savedLanguage && (savedLanguage === 'bg' || savedLanguage === 'en') ? savedLanguage : 'en';
    } catch (e) {
      return 'en';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('fireguard_language', language);
    } catch (e) {
      console.error('Failed to save language to localStorage:', e);
    }
  }, [language]);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to English if no translation
        value = translations.en;
        for (const k2 of keys) {
          if (value && value[k2]) {
            value = value[k2];
          } else {
            return key;
          }
        }
        break;
      }
    }
    
    return typeof value === 'string' ? value : key;
  }, [language]);

  const changeLanguage = useCallback((lang) => {
    if (!translations[lang]) return;
    if (lang === language) return;
    setLanguage(lang);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

